/* eslint-disable */ 
import React, { useEffect, useState, useRef } from "react";
import api from "../api/api"
import { Link, useHistory } from "react-router-dom";
import { InvoiceLogo1 } from "../_components/Imagepath";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import ForgotPasswordNotifications from "./ForgotPasswordNotifications";
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
import ReCAPTCHA from "react-google-recaptcha";

const ForgotPassword = (props) => {

  const recaptcha = useRef();
  const { t } = useTranslation();
  const history = useHistory();
  const [LoadingSubmit,setLoadingSubmit] = useState(false)
  const [SuccessSubmit,setSuccessSubmit] = useState(null)

  const schema = yup.object({
    email: yup
      .string()
      .matches(emailrgx, t("Email is required"))
      .required(t("Email is required"))
      .trim(),
    recaptcha: yup
      .string()
      .required(t("Please verify that you are not a robot")),
  });
  
  const inputValues = {
    email: "",
    recaptcha: "",
  };
  
  const {
    reset,
    handleSubmit,
    control,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: inputValues,
  });

  useEffect(() => {
    reset(inputValues);
  }, [reset]);

  const onSubmit = async(data) => {
    const recaptchaValue = recaptcha.current?.getValue();
    if (!recaptchaValue) {
      setError("root", { type: "manual", message: t("Please verify that you are not a robot") });
      return;
    }

    clearErrors();
    setSuccessSubmit(null)

    let typeurl = "auth/forgot-password/"

    if (LoadingSubmit) return;
    setLoadingSubmit(true);
    
    try {
      const response = await api.post(typeurl, data); 

      console.log("Response Code:", response.status);

      reset();
      setSuccessSubmit(response.data.result)
    } catch (error) {

           recaptcha.current.reset();
           
      console.log(error);
      
      let  errorMessage = ""
      
      // Extract response code if available
      const responseCode = error.response ? error.response.status : "Unknown";
      console.log("Response Code:", responseCode);
      if (error?.response?.data) {   
        errorMessage = 'Email not registered';
      }
          
      // If no specific error was found, provide a default message
      if (!errorMessage) {
        errorMessage = "An unknown error occurred.";
      }
      
      // Set the error message in React Hook Form
      setError("root", { type: "server", message: errorMessage });
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <>
    { !SuccessSubmit ? (
      <div className="main-wrapper login-body">
      <div className="login-wrapper">
        <div className="container">
          <img
            className="img-fluid logo-dark mb-2"
            src={InvoiceLogo1}
            alt="Logo"
          />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>{t("Forgot Password?")}</h1>
                <p className="account-subtitle">
                  {t("Enter your email to get a password reset link")}
                </p>

                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <div className="input-block mb-3">
                        <label className="form-control-label">{t("Email")}</label>
                        <input
                          {...field}
                          className="form-control"
                          type="text"
                          
                          onChange={(e) => {
                            field.onChange(e);      // keep RHF in sync
                            clearErrors("root");    // clear root error when typing
                          }}
                        />
                        <small style={{ color: "green" }}>
                          {SuccessSubmit && <p>{SuccessSubmit}</p>}
                        </small>
                        {errors.email && (
                          <small className="text-danger">{errors.email.message}</small>
                        )}
                        <small style={{ color: "red" }}>
                          {errors.root && <p>{errors.root.message}</p>}
                        </small>
                      </div>
                    )}
                  />
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    ref={recaptcha}
                    onChange={(value) => {
                      setValue("recaptcha", value);
                      if (value) {
                        clearErrors("recaptcha");
                      }
                    }}
                    onExpired={() => {
                      setValue("recaptcha", "");
                      setError("recaptcha", {
                        type: "manual",
                        message: t("ReCAPTCHA has expired, please verify again")
                      });
                    }}
                  />
                  {errors.recaptcha && (
                    <p className="text-danger">{errors.recaptcha.message}</p>
                  )}
                  
                  <div className="input-block mb-0">
                    <button
                      className="btn btn-lg btn-block w-100 btn-primary w-100"
                      type="submit"
                    >
                      {t("Reset Password")}
                    </button>
                  </div>
                </form>
                {/* /Form */}

                <div className="text-center dont-have">
                  {t("Remember your password?")} <Link to="/login">{t("Login")}</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="lang-menu">
                <ul className="nav nav-tabs user-menu">
                  <Lang />
                </ul>

              </div>
        </div>
      </div>
    </div>
    ) : (
      <ForgotPasswordNotifications />
    )
    }
    </>
  );
};
export default ForgotPassword;
